'use client'

import React from 'react'
import Image from 'next/image'
import { ARROW_RIGHT_URL, PREVIOUS_CHALLAN_CHECKS, PREVIOUS_FASTAG_CHECKS } from './constants'
import styles from './ChallanWidgetLanding.module.scss'

const ReturningUserInfoBlock = ({ userInfo, handleReturningSearch, isFastagWidget = false }) => (
  <div className={styles.returningUserBlockContainer}>
    <p className={styles.heading}>{isFastagWidget ? PREVIOUS_FASTAG_CHECKS : PREVIOUS_CHALLAN_CHECKS}</p>
    <div className={styles.infoContainer} onClick={handleReturningSearch}>
      <div className={styles.firstItem}>
        <span className={styles.brandLogo}>
          <Image width={20} height={20} src={userInfo?.logo_url} alt="Brand logo return user" />
        </span>
        <div className={styles.makeRegNo}>
          <p>{`${userInfo?.vehicleInfo?.db_make_name || ''} ${userInfo?.vehicleInfo?.db_model_name || ''}`}</p>&nbsp;
          <p>{`• ${userInfo?.vehicleInfo?.registration_number || ''}`}</p>
        </div>
      </div>
      <div className={styles.secondItem}>
        <Image width={20} height={20} src={ARROW_RIGHT_URL} alt="right arrow" />
      </div>
    </div>

    <div className={styles.orBox}>
      <p>OR</p>
    </div>
  </div>
)

export default ReturningUserInfoBlock
